var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTajmahal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 350,
    viewBox: "0 0 616 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_398_12396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 616,
    height: 350
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 616,
    height: 350,
    rx: 16,
    fill: "#0B1D4E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_398_12396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.402 202.629L180.477 204.031V182.959H186.402V202.629Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2075 117.961H43.2422V98.1246H65.2075V117.961Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2791 85.1177C56.0255 83.4854 54.2345 79.7474 54.2345 79.7474C54.2345 79.7474 52.4436 83.4854 49.1906 85.1177C45.937 86.7435 42.5234 88.2093 42.5234 95.0391H65.9463C65.9463 88.2093 62.5326 86.7435 59.2791 85.1177Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.832 96.5838C70.832 97.4351 70.1426 98.1328 69.2894 98.1328H39.1911C38.3378 98.1328 37.6484 97.4351 37.6484 96.5838C37.6484 95.7325 38.3378 95.0411 39.1911 95.0411H69.2894C70.1426 95.0411 70.832 95.7325 70.832 96.5838Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.832 119.52C70.832 120.371 70.1426 121.062 69.2894 121.062H39.1911C38.3378 121.062 37.6484 120.371 37.6484 119.52C37.6484 118.669 38.3378 117.971 39.1911 117.971H69.2894C70.1426 117.971 70.832 118.669 70.832 119.52Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0002 115.311H55.1427C55.1427 115.311 55.1427 107.982 55.1427 105.985C55.1427 103.981 55.9755 103.277 56.6092 102.663C57.6666 101.645 58.0718 100.96 58.0718 100.96C58.0718 100.96 58.4718 101.645 59.5338 102.663C60.1668 103.277 61.0002 103.981 61.0002 105.985C61.0002 107.982 61.0002 115.311 61.0002 115.311ZM53.1393 115.311H47.2773C47.2773 115.311 47.2773 107.982 47.2773 105.985C47.2773 103.981 48.1107 103.277 48.7476 102.663C49.8057 101.645 50.2064 100.96 50.2064 100.96C50.2064 100.96 50.6109 101.645 51.6728 102.663C52.3059 103.277 53.1393 103.981 53.1393 105.985C53.1393 107.982 53.1393 115.311 53.1393 115.311V115.311ZM63.1157 115.311C63.1157 115.311 63.1157 107.982 63.1157 105.985C63.1157 103.981 63.7135 103.277 64.1654 102.663C64.9188 101.645 65.2075 100.96 65.2075 100.96V98.1246H43.2422V100.96C43.2422 100.96 43.5552 101.645 44.3726 102.663C44.861 103.277 45.5023 103.981 45.5023 105.985C45.5023 107.982 45.5023 115.311 45.5023 115.311H43.2422V117.961H65.2075V115.311H63.1157Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8082 123.258H39.1094V121.056H40.8082V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9722 123.258H42.2734V121.056H43.9722V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1481 123.258H45.4531V121.056H47.1481V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3356 123.258H48.6406V121.056H50.3356V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4963 123.258H51.7969V121.056H53.4963V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6832 123.258H54.9844V121.056H56.6832V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8512 123.258H58.1562V121.056H59.8512V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0198 123.258H61.3203V121.056H63.0198V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1832 123.258H64.4844V121.056H66.1832V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3707 123.258H67.6719V121.056H69.3707V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.231 196.508H222.688V172.85H263.231V196.508Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.279 150.595C246.269 147.593 242.968 140.686 242.968 140.686C242.968 140.686 239.662 147.593 233.656 150.595C227.65 153.597 221.344 156.298 221.344 168.914H264.588C264.588 156.298 258.281 153.597 252.279 150.595Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.352 168.914H217.57V172.844H268.352V168.914Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.854 187.367V196.508H230.136V187.367C230.136 183.674 231.67 182.368 232.844 181.242C234.8 179.36 235.545 178.092 235.545 178.092C235.545 178.092 236.286 179.36 238.246 181.242C239.416 182.368 240.95 183.674 240.95 187.367V196.508H244.653V187.367C244.653 183.674 246.191 182.368 247.357 181.242C249.317 179.36 250.058 178.092 250.058 178.092C250.058 178.092 250.803 179.36 252.758 181.242C253.928 182.368 255.467 183.674 255.467 187.367V196.508H259.381V187.367C259.381 183.674 260.475 182.368 261.309 181.242C262.703 179.36 263.231 178.092 263.231 178.092V172.85H222.688V178.092C222.688 178.092 223.26 179.36 224.771 181.242C225.672 182.368 226.854 183.674 226.854 187.367Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.378 187.31C72.378 188.168 71.6848 188.859 70.8316 188.859H37.648C36.7948 188.859 36.1016 188.168 36.1016 187.31C36.1016 186.465 36.7948 185.768 37.648 185.768H70.8316C71.6848 185.768 72.378 186.465 72.378 187.31Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0894 191.062H37.3906V188.861H39.0894V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2809 191.062H40.5859V188.861H42.2809V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4566 191.062H43.7578V188.861H45.4566V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6246 191.062H46.9297V188.861H48.6246V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7965 191.062H50.1016V188.861H51.7965V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9918 191.062H53.2969V188.861H54.9918V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1441 191.062H56.4453V188.861H58.1441V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3238 191.062H59.625V188.861H61.3238V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4957 191.062H62.7969V188.861H64.4957V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6715 191.062H65.9766V188.861H67.6715V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8518 191.062H69.1562V188.861H70.8518V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3992 247.286C74.3992 248.137 73.7059 248.828 72.8521 248.828H36.1826C35.3294 248.828 34.6406 248.137 34.6406 247.286C34.6406 246.434 35.3294 245.743 36.1826 245.743H72.8521C73.7059 245.743 74.3992 246.434 74.3992 247.286Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9332 251.039H36.2344V248.837H37.9332V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1129 251.039H39.4141V248.837H41.1129V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2854 251.039H42.5859V248.837H44.2854V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4644 251.039H45.7656V248.837H47.4644V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6318 251.039H48.9375V248.837H50.6318V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8153 251.039H52.1172V248.837H53.8153V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9879 251.039H55.2891V248.837H56.9879V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1637 251.039H58.4688V248.837H60.1637V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3388 251.039H61.6406V248.837H63.3388V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5191 251.039H64.8203V248.837H66.5191V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6832 251.039H67.9844V248.837H69.6832V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8506 251.039H71.1562V248.837H72.8506V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.242 209.553C316.242 221.836 289.906 218.892 289.906 248.816C289.906 264.415 289.906 310.344 289.906 310.344H356.57C356.57 310.344 356.57 264.415 356.57 248.816C356.57 218.892 330.238 221.836 323.242 209.553Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.898 220.099C242.523 218.415 239.25 215.836 239.25 215.836C239.25 215.836 235.977 218.415 232.602 220.099C229.23 221.789 224.273 223.671 224.273 236.767C224.273 249.857 224.273 257.992 224.273 257.992H239.25H254.227C254.227 257.992 254.227 249.857 254.227 236.767C254.227 223.671 249.27 221.789 245.898 220.099V220.099Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.898 272.454C242.523 270.764 239.25 268.191 239.25 268.191C239.25 268.191 235.977 270.764 232.602 272.454C229.23 274.138 224.273 276.026 224.273 289.115C224.273 302.21 224.273 310.344 224.273 310.344H239.25H254.227C254.227 310.344 254.227 302.21 254.227 289.115C254.227 276.026 249.27 274.138 245.898 272.454V272.454Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.356 220.099C198.316 218.415 196.337 215.836 196.337 215.836C196.337 215.836 194.357 218.415 192.317 220.099C190.283 221.789 187.281 223.671 187.281 236.767C187.281 249.857 187.281 257.992 187.281 257.992H196.337H205.391C205.391 257.992 205.391 249.857 205.391 236.767C205.391 223.671 202.391 221.789 200.356 220.099Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.356 272.454C198.316 270.764 196.337 268.191 196.337 268.191C196.337 268.191 194.357 270.764 192.317 272.454C190.283 274.138 187.281 276.026 187.281 289.115C187.281 302.21 187.281 310.344 187.281 310.344H196.337H205.391C205.391 310.344 205.391 302.21 205.391 289.115C205.391 276.026 202.391 274.138 200.356 272.454Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.458 310.344H265.031V177.305H381.458V310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.016 310.344H212.32V196.501H265.016V310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.342 310.344H180.477V204.022L212.342 196.501V310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.32 201.069V205.281H265.016V201.069H212.32Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.477 208.585V212.797L212.342 205.282V201.07L180.477 208.585Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.866 310.344H283.617V196.501H362.866V310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9968 251.03V248.829H69.6956V251.03H67.9968ZM67.6845 191.06H65.9895V188.859H67.6845V191.06ZM66.5221 251.03H64.8233V248.829H66.5221V251.03ZM64.5109 191.06H62.8121V188.859H64.5109V191.06ZM63.3485 251.03H61.6503V248.829H63.3485V251.03ZM61.3373 191.06H59.6385V188.859H61.3373V191.06ZM60.1717 251.03H58.4768V248.829H60.1717V251.03ZM58.1644 191.06H56.4656V188.859H58.1644V191.06ZM56.9982 251.03H55.2994V248.829H56.9982V251.03ZM54.987 191.06H53.292V188.859H54.987V191.06ZM53.8246 251.03H52.1264V248.829H53.8246V251.03ZM51.8134 191.06H50.1185V188.859H51.8134V191.06ZM50.6472 251.03H48.9529V248.829H50.6472V251.03ZM48.6405 191.06H46.9455V188.859H48.6405V191.06ZM47.4743 251.03H45.7755V248.829H47.4743V251.03ZM45.4669 191.06H43.7681V188.859H45.4669V191.06ZM44.3013 251.03H42.6019V248.829H44.3013V251.03ZM42.2895 191.06H40.5946V188.859H42.2895V191.06ZM41.1278 251.03H39.429V248.829H41.1278V251.03ZM65.4486 123.256H64.5109V121.054H63.0368V123.256H61.3373V121.054H59.8594V123.256H58.1644V121.054H56.6858V123.256H54.987V121.054H53.5129V123.256H51.8134V121.054H50.3355V123.256H48.6405V121.054H47.1619V123.256H45.4669V121.054H43.9883V123.256H43.0512L37.9344 248.829H37.9542V251.03H37.846L35.4297 310.344H73.0695L65.4486 123.256Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.474 163.914H127.758V148.808H144.474V163.914Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.961 138.906C137.485 137.665 136.122 134.823 136.122 134.823C136.122 134.823 134.76 137.665 132.284 138.906C129.808 140.142 127.203 141.256 127.203 146.453H145.033C145.033 141.256 142.437 140.142 139.961 138.906V138.906Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.743 147.635C148.743 148.281 148.214 148.812 147.565 148.812H124.658C124.01 148.812 123.484 148.281 123.484 147.635C123.484 146.988 124.01 146.457 124.658 146.457H147.565C148.214 146.457 148.743 146.988 148.743 147.635Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.743 165.096C148.743 165.749 148.214 166.273 147.565 166.273H124.658C124.01 166.273 123.484 165.749 123.484 165.096C123.484 164.449 124.01 163.924 124.658 163.924H147.565C148.214 163.924 148.743 164.449 148.743 165.096Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.269 161.891H136.813C136.813 161.891 136.813 156.31 136.813 154.793C136.813 153.269 137.446 152.732 137.927 152.271C138.732 151.49 139.041 150.971 139.041 150.971C139.041 150.971 139.345 151.49 140.154 152.271C140.635 152.732 141.269 153.269 141.269 154.793C141.269 156.31 141.269 161.891 141.269 161.891ZM135.287 161.891H130.827C130.827 161.891 130.827 156.31 130.827 154.793C130.827 153.269 131.46 152.732 131.941 152.271C132.751 151.49 133.055 150.971 133.055 150.971C133.055 150.971 133.363 151.49 134.169 152.271C134.65 152.732 135.287 153.269 135.287 154.793C135.287 156.31 135.287 161.891 135.287 161.891ZM142.883 161.891C142.883 161.891 142.883 156.31 142.883 154.793C142.883 153.269 143.336 152.732 143.681 152.271C144.254 151.49 144.474 150.971 144.474 150.971V148.808H127.758V150.971C127.758 150.971 127.99 151.49 128.616 152.271C128.988 152.732 129.473 153.269 129.473 154.793C129.473 156.31 129.473 161.891 129.473 161.891H127.758V163.914H144.474V161.891H142.883Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.907 167.938H124.617V166.261H125.907V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.322 167.938H127.031V166.261H128.322V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.735 167.938H129.445V166.261H130.735V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.142 167.938H131.852V166.261H133.142V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.556 167.938H134.266V166.261H135.556V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.969 167.938H136.68V166.261H137.969V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4 167.938H139.109V166.261H140.4V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82 167.938H141.531V166.261H142.82V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.236 167.938H143.945V166.261H145.236V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.65 167.938H146.359V166.261H147.65V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.938 216.689C149.938 217.342 149.414 217.867 148.764 217.867H123.505C122.857 217.867 122.328 217.342 122.328 216.689C122.328 216.043 122.857 215.518 123.505 215.518H148.764C149.414 215.518 149.938 216.043 149.938 216.689Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.615 219.555H123.32V217.878H124.615V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.021 219.555H125.727V217.878H127.021V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.451 219.555H128.156V217.878H129.451V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.853 219.555H130.562V217.878H131.853V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.278 219.555H132.984V217.878H134.278V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.693 219.555H135.398V217.878H136.693V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.114 219.555H137.82V217.878H139.114V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.533 219.555H140.242V217.878H141.533V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.943 219.555H142.648V217.878H143.943V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.36 219.555H145.07V217.878H146.36V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.759 219.555H147.469V217.878H148.759V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.482 262.346C151.482 262.999 150.957 263.523 150.307 263.523H122.397C121.744 263.523 121.219 262.999 121.219 262.346C121.219 261.699 121.744 261.174 122.397 261.174H150.307C150.957 261.174 151.482 261.699 151.482 262.346Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.716 265.203H122.422V263.52H123.716V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13 265.203H124.836V263.52H126.13V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.56 265.203H127.266V263.52H128.56V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.977 265.203H129.688V263.52H130.977V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.396 265.203H132.102V263.52H133.396V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.798 265.203H134.508V263.52H135.798V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.215 265.203H136.922V263.52H138.215V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.646 265.203H139.352V263.52H140.646V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.051 265.203H141.758V263.52H143.051V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.462 265.203H144.172V263.52H145.462V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.884 265.203H146.594V263.52H147.884V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.297 265.203H149.008V263.52H150.297V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.599 265.202V263.519H147.889V265.202H146.599ZM146.358 219.551H145.068V217.874H146.358V219.551ZM145.469 265.202H144.178V263.519H145.469V265.202ZM143.942 219.551H142.648V217.874H143.942V219.551ZM143.056 265.202H141.763V263.519H143.056V265.202ZM141.527 219.551H140.236V217.874H141.527V219.551ZM140.641 265.202H139.346V263.519H140.641V265.202ZM139.11 219.551H137.816V217.874H139.11V219.551ZM138.224 265.202H136.931V263.519H138.224V265.202ZM136.694 219.551H135.4V217.874H136.694V219.551ZM135.804 265.202H134.514V263.519H135.804V265.202ZM134.277 219.551H132.984V217.874H134.277V219.551ZM133.393 265.202H132.098V263.519H133.393V265.202ZM131.862 219.551H130.571V217.874H131.862V219.551ZM130.972 265.202H129.682V263.519H130.972V265.202ZM129.446 219.551H128.151V217.874H129.446V219.551ZM128.56 265.202H127.266V263.519H128.56V265.202ZM127.03 219.551H125.735V217.874H127.03V219.551ZM126.144 265.202H124.85V263.519H126.144V265.202ZM144.655 167.94H143.942V166.263H142.816V167.94H141.527V166.263H140.401V167.94H139.11V166.263H137.984V167.94H136.694V166.263H135.568V167.94H134.277V166.263H133.152V167.94H131.862V166.263H130.736V167.94H129.446V166.263H128.32V167.94H127.607L123.713 263.519H123.728V265.202H123.644L121.805 310.344H150.457L144.655 167.94Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.785 179.442C183.907 179 183.423 177.989 183.423 177.989C183.423 177.989 182.942 179 182.064 179.442C181.187 179.877 180.266 180.274 180.266 182.117H186.585C186.585 180.274 185.663 179.877 184.785 179.442Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.995 182.537C186.995 182.767 186.807 182.953 186.579 182.953H180.26C180.028 182.953 179.844 182.767 179.844 182.537C179.844 182.307 180.028 182.121 180.26 182.121H186.579C186.807 182.121 186.995 182.307 186.995 182.537Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.289 196.507H212.628L209.367 197.211V174.904H215.289V196.507Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.679 171.387C212.802 170.945 212.322 169.934 212.322 169.934C212.322 169.934 211.841 170.945 210.96 171.387C210.082 171.822 209.164 172.219 209.164 174.062H215.479C215.479 172.219 214.557 171.822 213.679 171.387Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.914 174.482C215.914 174.713 215.73 174.898 215.497 174.898H209.182C208.95 174.898 208.766 174.713 208.766 174.482C208.766 174.252 208.95 174.066 209.182 174.066H215.497C215.73 174.066 215.914 174.252 215.914 174.482Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6726 346.211H30V310.347H77.6726V346.211Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6726 316.188H30V313.815H77.6726V316.188Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.803 346.211H77.6719V310.347H568.803V346.211Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.803 316.188H77.6719V313.815H568.803V316.188Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.43 310.344V288.995C331.43 284.482 327.768 280.82 323.252 280.82C318.732 280.82 315.07 284.482 315.07 288.995V310.344H331.43Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.863 310.344V298.335C243.863 295.795 241.8 293.731 239.26 293.731C236.719 293.731 234.656 295.795 234.656 298.335V310.344H243.863Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.863 258.109V246.101C243.863 243.56 241.8 241.499 239.26 241.499C236.719 241.499 234.656 243.56 234.656 246.101V258.109H243.863Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.078 202.629L466 204.031V182.959H460.078V202.629Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.25 117.961H603.211V98.1246H581.25V117.961Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.193 85.1177C590.451 83.4854 592.243 79.7474 592.243 79.7474C592.243 79.7474 594.029 83.4854 597.281 85.1177C600.533 86.7435 603.951 88.2093 603.951 95.0391H580.523C580.523 88.2093 583.941 86.7435 587.193 85.1177V85.1177Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.648 96.5838C575.648 97.4351 576.34 98.1328 577.191 98.1328H607.294C608.139 98.1328 608.837 97.4351 608.837 96.5838C608.837 95.7325 608.139 95.0411 607.294 95.0411H577.191C576.34 95.0411 575.648 95.7325 575.648 96.5838Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.648 119.52C575.648 120.371 576.34 121.062 577.191 121.062H607.294C608.139 121.062 608.837 120.371 608.837 119.52C608.837 118.669 608.139 117.971 607.294 117.971H577.191C576.34 117.971 575.648 118.669 575.648 119.52Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.455 105.985C585.455 103.981 586.287 103.277 586.921 102.663C587.984 101.645 588.387 100.96 588.387 100.96C588.387 100.96 588.79 101.645 589.846 102.663C590.48 103.277 591.312 103.981 591.312 105.985C591.312 107.982 591.312 115.311 591.312 115.311H585.455C585.455 115.311 585.455 107.982 585.455 105.985V105.985ZM593.316 105.985C593.316 103.981 594.148 103.277 594.781 102.663C595.844 101.645 596.247 100.96 596.247 100.96C596.247 100.96 596.651 101.645 597.707 102.663C598.34 103.277 599.179 103.981 599.179 105.985C599.179 107.982 599.179 115.311 599.179 115.311H593.316C593.316 115.311 593.316 107.982 593.316 105.985V105.985ZM581.25 115.311V117.961H603.211V115.311H600.952C600.952 115.311 600.952 107.982 600.952 105.985C600.952 103.981 601.592 103.277 602.085 102.663C602.904 101.645 603.211 100.96 603.211 100.96V98.1246H581.25V100.96C581.25 100.96 581.538 101.645 582.287 102.663C582.741 103.277 583.337 103.981 583.337 105.985C583.337 107.982 583.337 115.311 583.337 115.311H581.25Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.664 123.258H607.36V121.056H605.664V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.5 123.258H604.196V121.056H602.5V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.328 123.258H601.031V121.056H599.328V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.164 123.258H597.867V121.056H596.164V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.977 123.258H594.673V121.056H592.977V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.805 123.258H591.501V121.056H589.805V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.648 123.258H588.345V121.056H586.648V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.445 123.258H585.142V121.056H583.445V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.273 123.258H581.97V121.056H580.273V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.117 123.258H578.813V121.056H577.117V123.258Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.242 196.508H423.782V172.85H383.242V196.508Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.219 150.595C400.224 147.593 403.53 140.686 403.53 140.686C403.53 140.686 406.836 147.593 412.842 150.595C418.848 153.597 425.155 156.298 425.155 168.914H381.906C381.906 156.298 388.213 153.597 394.219 150.595Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.109 168.914H428.891V172.844H378.109V168.914Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.616 187.367V196.508H416.338V187.367C416.338 183.674 414.799 182.368 413.63 181.242C411.674 179.36 410.929 178.092 410.929 178.092C410.929 178.092 410.184 179.36 408.229 181.242C407.059 182.368 405.52 183.674 405.52 187.367V196.508H401.822V187.367C401.822 183.674 400.283 182.368 399.113 181.242C397.158 179.36 396.413 178.092 396.413 178.092C396.413 178.092 395.671 179.36 393.712 181.242C392.547 182.368 391.007 183.674 391.007 187.367V196.508H387.093V187.367C387.093 183.674 385.995 182.368 385.166 181.242C383.772 179.36 383.242 178.092 383.242 178.092V172.85H423.782V178.092C423.782 178.092 423.214 179.36 421.703 181.242C420.801 182.368 419.616 183.674 419.616 187.367V187.367Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.109 187.31C574.109 188.168 574.801 188.859 575.652 188.859H608.841C609.692 188.859 610.383 188.168 610.383 187.31C610.383 186.465 609.692 185.768 608.841 185.768H575.652C574.801 185.768 574.109 186.465 574.109 187.31Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.367 191.062H609.07V188.861H607.367V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.195 191.062H605.898V188.861H604.195V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.023 191.062H602.72V188.861H601.023V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.859 191.062H599.556V188.861H597.859V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.664 191.062H596.36V188.861H594.664V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.5 191.062H593.196V188.861H591.5V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.32 191.062H590.017V188.861H588.32V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.148 191.062H586.845V188.861H585.148V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.984 191.062H583.681V188.861H581.984V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.797 191.062H580.499V188.861H578.797V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.625 191.062H577.328V188.861H575.625V191.062Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.07 247.286C572.07 248.137 572.762 248.828 573.613 248.828H610.284C611.141 248.828 611.833 248.137 611.833 247.286C611.833 246.434 611.141 245.743 610.284 245.743H573.613C572.762 245.743 572.07 246.434 572.07 247.286Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.523 251.039H610.226V248.837H608.523V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.359 251.039H607.056V248.837H605.359V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.195 251.039H603.892V248.837H602.195V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.008 251.039H600.71V248.837H599.008V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.844 251.039H597.54V248.837H595.844V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.672 251.039H594.368V248.837H592.672V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.492 251.039H591.188V248.837H589.492V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.312 251.039H588.009V248.837H586.312V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.148 251.039H584.838V248.837H583.148V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.961 251.039H581.657V248.837H579.961V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.797 251.039H578.493V248.837H576.797V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.617 251.039H575.313V248.837H573.617V251.039Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.58 220.099C403.953 218.415 407.227 215.836 407.227 215.836C407.227 215.836 410.5 218.415 413.87 220.099C417.244 221.789 422.204 223.671 422.204 236.767C422.204 249.857 422.204 257.992 422.204 257.992H407.227H392.25C392.25 257.992 392.25 249.857 392.25 236.767C392.25 223.671 397.206 221.789 400.58 220.099Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.58 272.454C403.953 270.764 407.227 268.191 407.227 268.191C407.227 268.191 410.5 270.764 413.87 272.454C417.244 274.138 422.204 276.026 422.204 289.115C422.204 302.21 422.204 310.344 422.204 310.344H407.227H392.25C392.25 310.344 392.25 302.21 392.25 289.115C392.25 276.026 397.206 274.138 400.58 272.454Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.123 220.099C448.163 218.415 450.142 215.836 450.142 215.836C450.142 215.836 452.121 218.415 454.157 220.099C456.197 221.789 459.197 223.671 459.197 236.767C459.197 249.857 459.197 257.992 459.197 257.992H450.142H441.086C441.086 257.992 441.086 249.857 441.086 236.767C441.086 223.671 444.083 221.789 446.123 220.099Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.123 272.454C448.163 270.764 450.142 268.191 450.142 268.191C450.142 268.191 452.121 270.764 454.157 272.454C456.197 274.138 459.197 276.026 459.197 289.115C459.197 302.21 459.197 310.344 459.197 310.344H450.142H441.086C441.086 310.344 441.086 302.21 441.086 289.115C441.086 276.026 444.083 274.138 446.123 272.454Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.438 310.344H434.134V196.501H381.438V310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 310.344H466.014V204.022L434.148 196.501V310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.134 201.069V205.281H381.438V201.069H434.134Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.014 208.585V212.797L434.148 205.282V201.07L466.014 208.585Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.795 251.03V248.829H578.491V251.03H576.795ZM578.805 188.859H580.508V191.06H578.805V188.859ZM579.97 248.829H581.666V251.03H579.97V248.829ZM581.98 188.859H583.676V191.06H581.98V188.859ZM583.151 248.829H584.841V251.03H583.151V248.829ZM585.155 188.859H586.851V191.06H585.155V188.859ZM586.32 248.829H588.016V251.03H586.32V248.829ZM588.33 188.859H590.026V191.06H588.33V188.859ZM589.495 248.829H591.191V251.03H589.495V248.829ZM591.504 188.859H593.201V191.06H591.504V188.859ZM592.669 248.829H594.366V251.03H592.669V248.829ZM594.679 188.859H596.375V191.06H594.679V188.859ZM595.844 248.829H597.54V251.03H595.844V248.829ZM597.854 188.859H599.55V191.06H597.854V188.859ZM599.013 248.829H600.715V251.03H599.013V248.829ZM601.029 188.859H602.725V191.06H601.029V188.859ZM602.194 248.829H603.89V251.03H602.194V248.829ZM604.197 188.859H605.9V191.06H604.197V188.859ZM605.362 248.829H607.059V251.03H605.362V248.829ZM573.422 310.344H611.066L608.646 251.03H608.537V248.829H608.563L603.442 123.256H602.501V121.054H601.029V123.256H599.326V121.054H597.854V123.256H596.151V121.054H594.679V123.256H592.983V121.054H591.504V123.256H589.808V121.054H588.33V123.256H586.633V121.054H585.155V123.256H583.458V121.054H581.98V123.256H581.045L573.422 310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 163.914H518.716V148.808H502V163.914Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.499 138.906C508.975 137.665 510.337 134.823 510.337 134.823C510.337 134.823 511.7 137.665 514.176 138.906C516.652 140.142 519.252 141.256 519.252 146.453H501.422C501.422 141.256 504.023 140.142 506.499 138.906V138.906Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 147.635C497.719 148.281 498.244 148.812 498.893 148.812H521.803C522.452 148.812 522.977 148.281 522.977 147.635C522.977 146.988 522.452 146.457 521.803 146.457H498.893C498.244 146.457 497.719 146.988 497.719 147.635Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.719 165.096C497.719 165.749 498.244 166.273 498.893 166.273H521.803C522.452 166.273 522.977 165.749 522.977 165.096C522.977 164.449 522.452 163.924 521.803 163.924H498.893C498.244 163.924 497.719 164.449 497.719 165.096Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.202 154.793C505.202 153.269 505.835 152.732 506.315 152.271C507.125 151.49 507.429 150.971 507.429 150.971C507.429 150.971 507.738 151.49 508.547 152.271C509.028 152.732 509.661 153.269 509.661 154.793C509.661 156.31 509.661 161.891 509.661 161.891H505.202C505.202 161.891 505.202 156.31 505.202 154.793V154.793ZM511.188 154.793C511.188 153.269 511.821 152.732 512.302 152.271C513.111 151.49 513.415 150.971 513.415 150.971C513.415 150.971 513.724 151.49 514.529 152.271C515.01 152.732 515.647 153.269 515.647 154.793C515.647 156.31 515.647 161.891 515.647 161.891H511.188C511.188 161.891 511.188 156.31 511.188 154.793V154.793ZM502 161.891V163.914H518.716V161.891H516.997C516.997 161.891 516.997 156.31 516.997 154.793C516.997 153.269 517.486 152.732 517.859 152.271C518.48 151.49 518.716 150.971 518.716 150.971V148.808H502V150.971C502 150.971 502.221 151.49 502.794 152.271C503.138 152.732 503.591 153.269 503.591 154.793C503.591 156.31 503.591 161.891 503.591 161.891H502Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.57 167.938H521.865V166.261H520.57V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.164 167.938H519.458V166.261H518.164V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.75 167.938H517.04V166.261H515.75V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.328 167.938H514.622V166.261H513.328V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.906 167.938H512.2V166.261H510.906V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.484 167.938H509.779V166.261H508.484V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.07 167.938H507.364V166.261H506.07V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.648 167.938H504.943V166.261H503.648V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.242 167.938H502.536V166.261H501.242V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.828 167.938H500.122V166.261H498.828V167.938Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.539 216.689C496.539 217.342 497.065 217.867 497.713 217.867H522.972C523.621 217.867 524.146 217.342 524.146 216.689C524.146 216.043 523.621 215.518 522.972 215.518H497.713C497.065 215.518 496.539 216.043 496.539 216.689Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.867 219.555H523.158V217.878H521.867V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.445 219.555H520.735V217.878H519.445V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.039 219.555H518.33V217.878H517.039V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.625 219.555H515.915V217.878H514.625V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.203 219.555H513.494V217.878H512.203V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.797 219.555H511.09V217.878H509.797V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.375 219.555H508.666V217.878H507.375V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.945 219.555H506.24V217.878H504.945V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.523 219.555H503.814V217.878H502.523V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.125 219.555H501.415V217.878H500.125V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.711 219.555H499.001V217.878H497.711V219.555Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.008 262.346C495.008 262.999 495.536 263.523 496.186 263.523H524.097C524.746 263.523 525.271 262.999 525.271 262.346C525.271 261.699 524.746 261.174 524.097 261.174H496.186C495.536 261.174 495.008 261.699 495.008 262.346Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.75 265.203H524.044V263.52H522.75V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.336 265.203H521.626V263.52H520.336V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.914 265.203H519.204V263.52H517.914V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 265.203H516.79V263.52H515.5V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.086 265.203H514.38V263.52H513.086V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.68 265.203H511.97V263.52H510.68V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.273 265.203H509.568V263.52H508.273V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.836 265.203H507.126V263.52H505.836V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.422 265.203H504.717V263.52H503.422V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 265.203H502.29V263.52H501V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.586 265.203H499.876V263.52H498.586V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.188 265.203H497.479V263.52H496.188V265.203Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.584 265.202V263.519H499.874V265.202H498.584ZM500.114 217.874H501.405V219.551H500.114V217.874ZM501 263.519H502.29V265.202H501V263.519ZM502.53 217.874H503.821V219.551H502.53V217.874ZM503.416 263.519H504.711V265.202H503.416V263.519ZM504.942 217.874H506.237V219.551H504.942V217.874ZM505.832 263.519H507.122V265.202H505.832V263.519ZM507.362 217.874H508.653V219.551H507.362V217.874ZM508.248 263.519H509.543V265.202H508.248V263.519ZM509.779 217.874H511.072V219.551H509.779V217.874ZM510.664 263.519H511.955V265.202H510.664V263.519ZM512.195 217.874H513.485V219.551H512.195V217.874ZM513.08 263.519H514.374V265.202H513.08V263.519ZM514.611 217.874H515.901V219.551H514.611V217.874ZM515.496 263.519H516.787V265.202H515.496V263.519ZM517.027 217.874H518.318V219.551H517.027V217.874ZM517.913 263.519H519.202V265.202H517.913V263.519ZM519.443 217.874H520.733V219.551H519.443V217.874ZM520.328 263.519H521.619V265.202H520.328V263.519ZM496.016 310.344H524.664L522.828 265.202H522.745V263.519H522.756L518.862 167.94H518.149V166.263H517.027V167.94H515.737V166.263H514.611V167.94H513.317V166.263H512.195V167.94H510.901V166.263H509.779V167.94H508.485V166.263H507.362V167.94H506.068V166.263H504.947V167.94H503.652V166.263H502.53V167.94H501.817L496.016 310.344Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.685 179.442C462.566 179 463.048 177.989 463.048 177.989C463.048 177.989 463.533 179 464.41 179.442C465.283 179.877 466.204 180.274 466.204 182.117H459.891C459.891 180.274 460.812 179.877 461.685 179.442V179.442Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.477 182.537C459.477 182.767 459.661 182.953 459.894 182.953H466.208C466.441 182.953 466.624 182.767 466.624 182.537C466.624 182.307 466.441 182.121 466.208 182.121H459.894C459.661 182.121 459.477 182.307 459.477 182.537Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.195 196.507H433.856L437.117 197.211V174.904H431.195V196.507Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.791 171.387C433.669 170.945 434.15 169.934 434.15 169.934C434.15 169.934 434.635 170.945 435.512 171.387C436.389 171.822 437.315 172.219 437.315 174.062H430.992C430.992 172.219 431.915 171.822 432.791 171.387Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.578 174.482C430.578 174.713 430.767 174.898 430.995 174.898H437.318C437.546 174.898 437.731 174.713 437.731 174.482C437.731 174.252 437.546 174.066 437.318 174.066H430.995C430.767 174.066 430.578 174.252 430.578 174.482Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.805 346.211H616.472V310.347H568.805V346.211Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.805 316.188H616.472V313.815H568.805V316.188Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.617 310.344V298.335C402.617 295.795 404.677 293.731 407.221 293.731C409.761 293.731 411.82 295.795 411.82 298.335V310.344H402.617Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.617 258.109V246.101C402.617 243.56 404.677 241.499 407.221 241.499C409.761 241.499 411.82 243.56 411.82 246.101V258.109H402.617Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.43 259.961V246.852C331.43 242.333 327.768 238.672 323.252 238.672C318.732 238.672 315.07 242.333 315.07 246.852V259.961H331.43Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.32 239.664V259.961",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.008 239.664V259.961",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.242 238.672V259.961",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.07 251.266H331.43",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.07 256.109H331.43",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.109 246.367H331.368",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.453 242.273H330.032",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.761 49.8609C327.761 52.3509 325.746 54.3672 323.262 54.3672C320.769 54.3672 318.758 52.3509 318.758 49.8609C318.758 47.3774 320.769 45.3611 323.262 45.3611C325.746 45.3611 327.761 47.3774 327.761 49.8609Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.754 42.6095C326.754 44.549 325.187 46.1172 323.252 46.1172C321.312 46.1172 319.742 44.549 319.742 42.6095C319.742 40.67 321.312 39.1018 323.252 39.1018C325.187 39.1018 326.754 40.67 326.754 42.6095Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.754 31.6564C326.754 33.5959 325.187 35.1641 323.252 35.1641C321.312 35.1641 319.742 33.5959 319.742 31.6564C319.742 29.7169 321.312 28.1486 323.252 28.1486C325.187 28.1486 326.754 29.7169 326.754 31.6564Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.261 28.143C323.742 28.143 324.203 28.2455 324.62 28.4183V19.4058C324.62 19.4058 324.479 17.9976 323.221 17.9976C321.967 17.9976 321.867 19.4058 321.867 19.4058V28.4375C322.292 28.2519 322.765 28.143 323.261 28.143Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.867 34.8652V39.3906C322.292 39.205 322.765 39.0962 323.261 39.0962C323.742 39.0962 324.203 39.1922 324.62 39.3714V34.8844C324.203 35.0573 323.742 35.1597 323.261 35.1597C322.765 35.1597 322.292 35.0508 321.867 34.8652V34.8652Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.258 54.3672H324.617V54.156C324.189 54.2968 323.731 54.3672 323.258 54.3672Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.867 54.3672H323.261C322.773 54.3672 322.308 54.284 321.867 54.1432V54.3672Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.254 142.507C274.187 142.507 270.758 147.403 270.758 147.403V161.383C270.758 161.383 275.018 156.179 323.254 156.179C371.487 156.179 375.746 161.383 375.746 161.383V147.403C375.746 147.403 372.313 142.507 323.254 142.507Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.605 104.186C364.155 79.2225 338.324 70.0116 324.485 54.2014C324.096 54.3038 323.692 54.3678 323.27 54.3678C322.838 54.3678 322.422 54.3038 322.029 54.1886C308.19 70.0116 282.355 79.2161 266.896 104.186C250.966 129.924 270.759 147.398 270.759 147.398C270.759 147.398 274.188 142.502 323.255 142.502C372.313 142.502 375.747 147.398 375.747 147.398C375.747 147.398 395.54 129.924 379.605 104.186V104.186Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.254 156.169C275.018 156.169 270.758 161.373 270.758 161.373V177.305H375.746V161.373C375.746 161.373 371.487 156.169 323.254 156.169Z",
    stroke: "#3B61AE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajmahal);
export default __webpack_public_path__ + "static/media/TAJMAHAL.10e6c9881fe25ec83f08e552306a9de8.svg";
export { ForwardRef as ReactComponent };